import React from "react"
import "./ProductFlag.styl"

export default ({ color, label }) => {
  return <div className={`ProductFlag ${color}`}>{label}</div>
}
